import { LOCALES } from 'i18n/locales';

export const dialogIntl = {
    [LOCALES.ENGLISH]: {
        'dialog.share': 'You are about to share a link: ',
        'dialog.delete': 'You are about to delete: ',
        'dialog.restrictedLink': 'This link is restricted, only people with access to NUAR can access it.',
        'dialog.areYouSure': 'Are you sure?',
        'dialog.link': 'URL',
        'dialog.copy': 'Copy'
    },
    [LOCALES.WELSH]: {
        'dialog.share': 'Rydych ar fin rhannu dolen: ',
        'dialog.delete': 'Rydych chi ar fin dileu: ',
        'dialog.restrictedLink': 'Mae\'r ddolen hon wedi\'i chyfyngu, dim ond pobl sydd â mynediad i NUAR sy\'n gallu cael mynediad iddi.',
        'dialog.areYouSure': 'Ydych chi\'n siŵr?',
        'dialog.link': 'URL',
        'dialog.copy': 'Copïo'
    }
};
